export class Knif {
  public static fromFirstSetting(values: any) {
    return new Knif({
      id: values.id,
      diameter: values.diameter,
      type: values.type,
      moveSpeed: values.moveSpeed,
      doSpeed: values.doSpeed,
      startCode: values.startCode,
      endCode: values.endCode,
    })
  }
  public static fromThirdSetting(values: any) {
    return new Knif({
      knifeName: values.knifeName,
      diameter: values.diameter,
      moveSpeed: values.moveSpeed,
      doSpeed: values.doSpeed,
      startCode: values.startCode,
      endCode: values.endCode,
      holeable: Boolean(values.holeable),
      slotable: Boolean(values.slotable),
      millable: Boolean(values.millable),
      appoint: Boolean(values.appoint),
      webId: values.webId,
    })
  }
  public static fromFourthSetting(values: any) {
    return new Knif({
      knifeName: values.knifeName,
      diameter: values.diameter,
      startCode: values.startCode,
      endCode: values.endCode,
    })
  }

  public id = ''
  public knifeName = ''
  public diameter = ''
  public type = ''
  public moveSpeed = ''
  public doSpeed = ''
  public startCode = ''
  public endCode = ''
  public appoint = false
  public holeable = false
  public slotable = false
  public millable = false
  public webId = ''

  constructor(props: Partial<Knif>) {
    Object.assign(this, props)
  }
}

export interface ColumnType {
  label: string
  props: string
  canEdit?: boolean
  isTextarea?: boolean
  width?: number
  isCustom?: boolean
  align?: 'left' | 'center' | 'right'
  isInputCheck?: boolean
}
